export default __webpack_public_path__ + "static/media/clock.afb1ba24.svg";